
import 'normalize.css';
import 'html/help/help.css';


import _ from 'underscore'
import $$ from 'jquery'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import { api } from 'html/help/config';
// 日活上报
import dailyReport from 'daily-report'

// import questionList from 'html/help/data/question_list';

var help = (function($) {

  function parseUrl(url = window.location.href) {
    var a = document.createElement('a')
    a.href = url
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function() {
            var ret = {},
                seg = a.search.replace(/^\?/, '').split('&'),
                len = seg.length,
                i = 0,
                s
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue
                }
                s = seg[i].split('=')
                ret[s[0]] = s[1]
            }
            return ret
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [null, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [null, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    }
  };

  // 展示列表还是详情
  function showView(listID, detailID){
    if(listID) {
      // $('.J_category_list li[data-type='+listID+']').trigger('click');
      let $list = $('.J_category_list li[data-type='+listID+']');
      help.showList($list);
    } else if(detailID) {
      // 详情
      help.render('detail', detailID);
      help.$helpListEl.addClass('none');
      help.$detailEl.removeClass('none');
    }
  };

  // 浏览器history记录
  if (!!(window.history && history.pushState)) {
    // 支持History API
    window.addEventListener('popstate', function(event) {
      if(event.state) {
        let oState = event.state;
        let listID = oState && oState['list'];
        let detailID = oState && oState['detail'];
        help.getLandingPageInfo()
        showView(listID, detailID);
      }
    });
  }

  return {
    listType: 11,
    listNama:'常见问题',
    cateList:[],
    landing_page_id:'',
    init1(){
      this.getLandingPageInfo()
    },
    init() {

      help.bindEvent();
      // 刷新页面定位问题
      let oURL = parseUrl(location);
      if(oURL.query) {
        let listID = oURL.params && oURL.params['list'];
        let detailID = oURL.params && oURL.params['detail'];

        showView(listID, detailID);
      } else {
        // 定位到常见问题
        $('.J_category_list li[data-type="11"]').trigger('click');
      }

      NProgress.start();
      setTimeout(function() {
        NProgress.done();
      }, 500);
    },
    // categoryList: this.questionList && this.questionList.data && this.questionList.data.categories,
    bindEvent() {
      let self = this;
      let $searchList = this.$searchList = $('.J_search_list_wrapper');
      let $helpListEl = this.$helpListEl = $('.J_help_list');
      let $detailEl = this.$detailEl = $('.J_help_detail');
      let $searchIPT = $('.J_search_ipt');

      /*
       * 搜索相关
       */

      // 关键词相关问题
      $('.J_search_ipt').on('keyup', function(evt) {
        let $el = $(this);
        let keyWord = $el.val().trim();

        keyWord && self.seachQuestion(keyWord);
        keyWord && $searchList.removeClass('none');
        !keyWord && $searchList.addClass('none');

        function search(){
          self.seachQuestion($el.val());
        }

        if (evt.keyCode === 13) {
            self.seachQuestion(keyWord);
        }

        // 防止重复调用
        // _.throttle(search, 100);
      });

      $('.J_search').on('click', function(evt) {
        let keyWord = $searchIPT.val().trim();

        keyWord && self.seachQuestion(keyWord);

        setTimeout(function() {
            keyWord && $searchList.removeClass('none');
          }, 150);
      });


      // 展示热门问题
      $('.J_search_ipt').focus(function(evt) {
        let $el = $(this);
        let keyWord = $el.val().trim();

        keyWord && $searchList.removeClass('none');
      }).click(function(evt) {
        let keyWord = $searchIPT.val().trim();
        keyWord && $searchList.removeClass('none');
      }).blur(function() {
        setTimeout(function(){
            $searchList.addClass('none');
          }, 150);
      });


      $('.J_search_area').hover(function (evt) {
          let keyWord = $searchIPT.val().trim();
          $searchIPT.is( ':focus' ) && keyWord && $searchList.removeClass('none');
        },
        function () {
          !$searchIPT.is( ':focus' ) && $searchList.addClass('none');
        }
      );

      // 类目切换
      $('.J_category_list').on('click', function(evt){
        //
        let $el = $(evt.target);
        let type = +$el.data('type');
        let name = $el.data('title');

        if(type) {
          $el.addClass('curr').siblings('.curr').removeClass('curr');
          // render 问题列表
          self.render('list', type, name);

          // 判断是否在详情页
          if($helpListEl.hasClass('none')) {
            $helpListEl.removeClass('none');
            $detailEl.addClass('none');
          }

          // 通过pushstate定位
          self.listType = type;
          self.listNama = name;
          !!(window.history && history.pushState) && history.pushState({ list: type }, null, '?list='+type);
        }
      });

      // 进入问题详情
      $('.J_page').delegate('.J_question_list', 'click', function(evt){
        //
        let $el = $(evt.target);
        let id = +$el.data('id');

        if(id) {
          self.render('detail', id);
          if(!$searchList.hasClass('none')) $searchList.addClass('none');
          $helpListEl.addClass('none');
          $detailEl.removeClass('none');

          // 通过pushstate定位
          !!(window.history && history.pushState) && history.pushState({ detail: id }, null, '?detail='+id);
        }
      });

      // 详情返回
      $('.J_back').on('click', function(evt) {
        // history.back();
        $helpListEl.removeClass('none');
        $detailEl.addClass('none');

        // 通过pushstate定位
        let type = self.listType;
        let name = self.listNama
        !!(window.history && history.pushState) && history.replaceState({ list: type }, null, '?list='+type);
        self.$detailEl.find('.J_detail').empty();
        self.render('list', type, name);
      });

      // 点赞
      $('.J_page').delegate('.J_digg', 'click', function(evt){
        let $el = $(this);
        let id = +$el.data('id');
        let count = +$el.find('.digg-count').html();

        var callback = function(data){
          $el.hide();
          $el.parent().find('.J_digged').show().find('.digg-count').html(count+1);
        }

        self.digg(id, callback);
      });
    },
    // 显示列表
    showList($el) {
      let type = +$el.data('type');
      let name = $el.data('title');
      if(type) {
        $el.addClass('curr').siblings('.curr').removeClass('curr');
        // render 问题列表
        this.render('list', type, name);

        // 判断是否在详情页
        if(this.$helpListEl.hasClass('none')) {
          this.$helpListEl.removeClass('none');
          this.$detailEl.addClass('none');
        }
      }
    },
    digg(ID, callback){
      let self = this;

      $.ajax({
        url: api.digg+ ID +'/likes',
        type: 'post',
        data: null,
        dataType: "json",
        success: function (data, status) {
          if(data.success) {
            console && console.log(data);
            callback(data);
          }
        },
        error: function (xhr, errorType, error) {
          console && console.log(error);
        }
      });
    },
    // 渲染列表，详情等
    render(type, ID, name) {
      if(type) {
        switch(type){
          case 'list':
            this.renderList(ID, name);
            break;
          case 'detail':
            this.renderDetail(ID);
            break;
          default : break;
        }
      }
    },
    renderList(ID, title) {
      let self = this;
      let tpl = _.template($('#J_help_list_tpl').html());
      let tempList = self.cateList.find(item => {
        return item.id == ID
      })
      if(tempList){
        let group = {
          id:ID,
          name : title,
          questions:tempList.list
        };  
        self.$helpListEl.html(tpl(group));
      }
    },
    renderDetail(ID) {
      let isLoading = true;
      let self = this;
      let tpl = _.template($('#J_help_detail_tpl').html());
      // 进度条
      NProgress.start();
      setTimeout(function() {
        NProgress.set(0.75);
      }, 100);

      //
      setTimeout(function() {
        NProgress.done();
      }, 2000);


      $.ajax({
        url: api.get_question+ ID,
        type: 'get',
        data: null,
        dataType: "json",
        success: function (res, status) {
          if(res.success) {
            let data = res.data.question;
            self.$detailEl.find('.J_detail').html(tpl(data));
            self.$detailEl.find('.J_detail').load(function(){
                NProgress.done();
                isLoading = false;
            });
          }
        },
        error: function (xhr, errorType, error) {
          console && console.log(error);
        }
      });
    },
    // 搜索问题
    seachQuestion(keyWord){
      let self = this;
      let tpl = _.template($('#J_search_list_tpl').html());

      $.ajax({
        url: api.search_questions+'?landing_page_id='+self.landing_page_id+'&&search='+keyWord,
        type: 'get',
        data: null,
        dataType: "json",
        success: function (res, status) {
          if(res.success) {
            if(res.data && res.data.length){
              let data = {
                questions:res.data.map(item => {
                  return {
                    id:item.id,
                    title:self.formatHtml(item.title,keyWord,item.id)
                  }
                })
              }
              self.$searchList.find('.J_question_list').html(tpl(data));
            } else {
              let data = {
                questions:[]
              }  
              self.$searchList.find('.J_question_list').html(tpl(data));
            }
          }
        },
        error: function (xhr, errorType, error) {
          console && console.log(error);
        }
      });
    },
  /**
  * @method 获取落地页信息
  */
  getLandingPageInfo(){
    let self = this;
    $.get(api.get_landing_page_info,
    function (res, status) {
      if(res.success) { 
        if(res.data.length){
          self.landing_page_id = res.data[0].id // 取第一个落地页id
          self.getCategoryList(self.landing_page_id)
        } else { // // 没有配置落地页时，也需要init,否则页面上的默认文章将没有点击事件
          self.init() 
        }
      } else { // 落地页接口失败时，也需要init,否则页面上的默认文章将没有点击事件
        self.init()
      }
    });    
  },
  /**
  * @method 获取一级类别列表
  * @param {Number|String} 落地页id
  */
  getCategoryList(id){
    let self = this;
    let tpl = _.template($('#J_top_level_help_list_tpl').html());
    $.get(api.get_category_list,{landing_page_id:id},
      function (res, status) {
        if(res.success) { 
          if(res.data.categories_list && res.data.categories_list.length){
            self.cateList = res.data.categories_list.map(item => {
              return {
                id:item.id,
                title:item.title,
                list:self.getAllChild([],item)
              }
            })
            let group = {
              categories:self.cateList,
            };
            $('#J_category_list_top').html(tpl(group));
            self.init()
          } else { // 落地页模块下没有文章时，也需要init,否则页面上的默认文章将没有点击事件
            self.init()
          }
        }
      }); 
  },
  /**
  * @method 递归获取分类下所有文章
  * @param {Array} 存储当前一级分类下的所有文章
  * @param {Object} 每个一级分类及其包含的下的二级分类及文章
  * @return {Array} 每个一级分类下文章组成的数组
  */
   getAllChild(tempList = [],item){
     let self = this
    if(!item.classification){ // 是文章
      tempList.push({
        id:item.id,
        title:item.title
      })
    } else {
      if(item.children && item.children.length){
        item.children.forEach(idx => {
          self.getAllChild(tempList,idx)
        });
      }
    }
    return tempList
  },
  /**
  * @method 高亮关键字
  * @param {String} 文案片段-富文本
  * @param {String} 关键字
  * @param {String} 标识id
  * @return {String} 高亮后的string
  */
  formatHtml(html,keyWord,id){
    if(!html){
      return;
    }
    //剔出<html>的标签 
    let formatContent = html.replace(/<[^>]+>/g, ""); 
    //去除字符串中的空格,回车,换行符,制表符
    formatContent = formatContent.replace(/\\s*|\t|\r|\n/g, "");
    //替换&nbsp;
    formatContent = formatContent.replace(/&nbsp;/g, " ");
    //高亮关键字
    let reg = new RegExp(keyWord, 'g');
    // 替换时，需要加入data-id，为了解决，监听click事件时，通过target捕捉不到id的问题
    formatContent = formatContent.replace(reg, `<span class="highlight" data-id="${id}">${keyWord}</span>`);
    return formatContent;
  },  
  }
})($$);

// dom 加载完成初始化
$$(document).ready(function(){
  help.init1();

  // 统计
  setTimeout(()=>{
    typeof dailyReport !== 'undefined' && dailyReport.reportLog();
  }, 2000);
});





// WEBPACK FOOTER //
// ./src/html/help/help.js